<template>
  <!--  医生详情介绍页面-->
  <div id="mainBody">
    <div id="mainBodyS">
      <breadcrumb msg="文章" msg1="正文"></breadcrumb>
      <div id="contentsOfArticle">
        <h2>{{doctor.name}}</h2>
        <!-- <h5>发布时间：{{doctor.gmtCreate}}</h5> -->
        <div style="text-align:center">
          <img style="width:180px;height:250px" :src="doctor.src" alt/>
        </div>
        <div class="str">{{doctor.summary}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import breadcrumb from "../components/breadcrumb1";
  import {doctorInfo} from '../../api/api.js'

  export default {
    data() {
      return {
        doctorForms: JSON.parse(sessionStorage.getItem('doctorForms')),
        divisionList: JSON.parse(sessionStorage.getItem('divisionList')),
        doctor: {}
      };
    },
    created() {
      if (this.$route.query.id) {
        this.getInfo(this.$route.query.id)
      }
    },
    components: {breadcrumb},
    methods: {
      getInfo(id) {
        doctorInfo({id: id}).then(res => {
          if (res.data.code === 200) {
            this.doctor = res.data.data
          }
        })
      }
    }
  };
</script>
<style lang="less" scoped>
  #mainBodyS {
    width: 1200px;
    min-height: 550px;
    margin: 0 auto;
    padding: 40px;

    #contentsOfArticle {
      margin-top: 80px;

      .str {
        text-indent: 2rem;
        margin-top: 40px;
      }

      h2,
      h5 {
        text-align: center;
      }
    }
  }
</style>
<style lang="less">
  #mainBody {
    background-image: url(../assets/img/jkjt3.jpg);
    background-size: 100% 100%;

    /deep/ #address {
      color: rgb(69, 109, 171);
      font-size: 15px;
      font-weight: 600;
    }

    //   /deep/ .el-breadcrumb__inner {
    //     color: #ffffff;
    //   }
    /deep/ .el-breadcrumb__inner a,
    .el-breadcrumb__inner.is-link {
      color: rgb(69, 109, 171) !important;
    }

    /deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
      color: rgb(69, 109, 171) !important;
      font-weight: 600 !important;
    }

    /deep/ .el-breadcrumb__separator {
      color: rgb(69, 109, 171) !important;
    }
  }
</style>
